import { IDailyReportResponse, IMissingDaysResponse } from '../../interfaces/daily-report.interface'

export interface DailyReportsStateModel {
  dailyReport: IDailyReportResponse
  missingDays: IMissingDaysResponse[]
  dailyReportChanged: boolean
}
